export default __webpack_public_path__ + "static/media/silver.402a7331.svg";